import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { take } from 'rxjs/operators';

import { TaskService } from '../../../../core/timeline';
import { TaskMode } from '../enums';

@Component({
  selector: 'kt-warn-create-duplicate-task',
  templateUrl: './warn-create-duplicate-task.component.html',
  styleUrls: ['./warn-create-duplicate-task.component.scss'],
})
export class WarnCreateDuplicateTaskComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public matchedTasks,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<WarnCreateDuplicateTaskComponent>,
    private taskService: TaskService,
  ) {}

  openTask(taskId: number): void {
    this.taskService
      .getTaskV3(taskId)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.data) return;

        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = '95vw';
        dialogConfig.maxWidth = '95vw';
        dialogConfig.data = { mode: TaskMode.VIEW, task: res.data };

        // Loaded lazily: CreateTaskComponent opens this dialog, so a static import would be circular.
        import('../create-task/create-task.component').then(({ CreateTaskComponent }) =>
          this.dialog.open(CreateTaskComponent, dialogConfig),
        );
      });
  }

  close(event: Event, confirmed = false): void {
    event.stopPropagation();

    this.dialogRef.close(confirmed);
  }
}
